import './FrequencyVisualizer.css'
import React, { Component } from 'react';
import PropTypes from "prop-types";

class FrequencyVisualizer extends Component {
  static propTypes = {
    analyser: PropTypes.object,
    show: PropTypes.bool
  }
  constructor(props) {
    super(props);
    this.canvas = React.createRef();

    this.draw = this.draw.bind(this);
    this.updateFrequencyData = this.updateFrequencyData.bind(this);
  }

  componentDidMount() {
    this.updateFrequencyData();
  }

  draw(audioData) {
    if(audioData && this.canvas.current){
      const canvas = this.canvas.current;
      const height = canvas.height;
      const width = canvas.width;
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, width, height);

      for (let i = 0; i < audioData.length; i++) {
        const percent = audioData[i] / 255;
        const barHeight = height * percent;
        const offset = height - barHeight - 1;
        const barWidth = width / audioData.length;
        if(barHeight === 0) {
          context.fillStyle = 'rgb(173, 181, 189)';
        }else{
          context.fillStyle = 'rgb(96,128,255)';
        }
        context.fillRect(i * barWidth, offset, barWidth, 2);
      }
    }
  }

  updateFrequencyData = () => {
    if(this.props.analyser){
      let audioData = new Uint8Array(this.props.analyser.frequencyBinCount);
      this.props.analyser.getByteFrequencyData(audioData);
      this.draw(audioData);
      requestAnimationFrame(this.updateFrequencyData);
    }
  }

  render() {
    if(!this.props.show){
      return null;
    }
    return <canvas className="FrequencyVisualizer" width="340" height="60" ref={this.canvas} />;
  }
}

export default FrequencyVisualizer;